import { Badge } from '../../../components/ui';
import { useT } from '../../../i18n';
import { ngayVN, soVN } from '../../../lib/dinh-dang';
import { LOAI_YEU_CAU_TOKEN, TRANG_THAI_YEU_CAU_TOKEN } from '../constants';
import type { AiTokenRequest, AiTokenRequestKind, AiTokenRequestStatus } from '../types';
import { ChupGia } from '../../goi-nap-token/components/GiaHienThi';
import { useNhanThoiHan } from './nhan-thoi-han';

export function BadgeLoaiToken({ loai }: { loai: AiTokenRequestKind }) {
  const { t } = useT();
  const b = LOAI_YEU_CAU_TOKEN[loai];
  return <Badge variant={b.variant}>{t(b.khoa)}</Badge>;
}

export function BadgeTrangThaiYeuCau({ trangThai }: { trangThai: AiTokenRequestStatus }) {
  const { t } = useT();
  const b = TRANG_THAI_YEU_CAU_TOKEN[trangThai];
  return <Badge variant={b.variant}>{t(b.khoa)}</Badge>;
}

/**
 * Một dòng tóm tắt điều yêu cầu xin, dùng chung ở hàng chờ của Platform Admin và danh sách của Tenant Admin.
 * Đã duyệt thì thêm dòng phụ "Đã duyệt: …" với số và khoảng hiệu lực thật — Tenant Admin cần biết mình được gì, tới bao giờ.
 */
export function NoiDungYeuCauToken({ r, day }: { r: AiTokenRequest; /** Hiện cả tỷ giá và ngày của ảnh chụp giá. */ day?: boolean }) {
  const { t, locale } = useT();
  const nhanThoiHan = useNhanThoiHan();
  const thoiHan = r.duration_count === null ? '' : nhanThoiHan(r.duration_unit ?? 'MONTH', r.duration_count);
  const chinh =
    r.kind === 'NAP_TOKEN'
      ? t('banToken.yeuCau.ndNapToken', { so: soVN(r.tokens, locale), thoiHan })
      : r.kind === 'NAP_THEM'
      ? t('tokenAi.ndNapThem', { so: soVN(r.tokens, locale), thoiHan })
      : r.kind === 'GOI_TAM_THOI'
        ? t('tokenAi.ndGoiTamThoi', { so: soVN(r.tokens, locale), thoiHan })
        : t('tokenAi.ndGiaHanGoiTamThoi', { den: ngayVN(r.valid_to) });

  // Đã duyệt: nạp thêm, gói tạm thời luôn nói khoảng hiệu lực thật (tính từ ngày duyệt); gia hạn chỉ khi ngày khác.
  const dongDuyet =
    r.status !== 'APPROVED'
      ? null
      : r.kind === 'GIA_HAN'
        ? r.approved_valid_to !== null && r.approved_valid_to !== r.valid_to
          ? t('tokenAi.ndDaDuyetNgay', { den: ngayVN(r.approved_valid_to) })
          : null
        : t('tokenAi.ndDaDuyet', {
            so: soVN(r.approved_tokens, locale),
            tu: ngayVN(r.approved_valid_from),
            den: ngayVN(r.approved_valid_to),
          });

  return (
    <div className="flex min-w-0 flex-col gap-0.5">
      <span className="text-sm tabular-nums text-content-primary">{chinh}</span>
      {r.top_up && <ChupGia chup={r.top_up} gon={!day} />}
      {dongDuyet && <span className="text-2xs tabular-nums text-success-700">{dongDuyet}</span>}
    </div>
  );
}
